var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "@mui/material";
import { Facebook as FacebookIcon, Twitter as TwitterIcon, Instagram as InstagramIcon, Pinterest as PinterestIcon } from "@mui/icons-material";
var SharedSocialIcons = function (props) {
    return (_jsxs("div", __assign({ className: "ST-Icons", style: { marginTop: "1rem" } }, { children: [_jsx(Link, __assign({ target: "_blank", href: "http://pinterest.com/pin/create/bookmarklet/?is_video=false&url=" + props.url }, { children: _jsx(PinterestIcon, { sx: { mr: 2, color: "#d01313" } }) })), _jsx(Link, __assign({ target: "_blank", href: "https://www.instagram.com/###?ref=" + props.url }, { children: _jsx(InstagramIcon, { sx: { mr: 2, color: "#c54e63" } }) })), _jsx(Link, __assign({ target: "_blank", href: "https://twitter.com/share?url=" + props.url }, { children: _jsx(TwitterIcon, { sx: { mr: 2, color: "#00a7eb" } }) })), _jsx(Link, __assign({ target: "_blank", href: "http://www.facebook.com/sharer.php?u=" + props.url }, { children: _jsx(FacebookIcon, { sx: { mr: 2, color: "#00007e" } }) }))] })));
};
export default SharedSocialIcons;
